// @flow
import type { Styles } from './types';

const styles: Styles = unusedTheme => ({
  root: {},
});

export default styles;
